export default __webpack_public_path__ + "static/media/RealTimeUI_2.e27fb741.svg";